export const SET_LAYER_PRODUCTS = 'SET_LAYER_PRODUCTS';
export const RESET_LAYER_PRODUCTS = 'RESET_LAYER_PRODUCTS';
export const SET_LOADING_LAYER = 'SET_LOADING_LAYER';
export const SET_CURRENT_LAYER = 'SET_CURRENT_LAYER';
export const APPEND_ITEMS = 'APPEND_ITEMS';